module.exports = __webpack_public_path__ + "static/media/icon-hr-dashboard-grey.603b2a3a.svg";